import { BottomNavigation, BottomNavigationAction, Paper } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import AuthContext from '../../context/AuthContext';
import ApiService from '../../functions/apiService';

export default function MyShiftsTableHeader({ step = 0, value = 0, setValue = () => { } , handleLoadOT }) {
    const [searchParams] = useSearchParams();
    const { pages } = useContext(AuthContext);
		const [allowedVars , setAllowedVars] = useState({})
    const routeStep = searchParams.get('step');
		const [pillHeading, setPillHeading] = useState('')
		

		let getAllowedVars = () => {
			ApiService.get('/v3Variables')
				.then((res) => {
					setAllowedVars(res?.data?.data)
					setPillHeading(res?.data?.data?.V3_VERBIAGE_VOLUNTEER ? "Per-diem Positions" : "Volunteer Positions")
				}).catch(({ error }) => {
					console.error('error', error)
				});
		}
	
		useEffect(()=>{
			getAllowedVars();
		}, [])

    useEffect(() => {
        if (routeStep) {
            setValue(routeStep);
        }
    }, [routeStep, setValue]);

    return (
        <Paper elevation={0}>
            <BottomNavigation
                sx={{
                    overflow: "auto",
                }}
                className='flex-wrap justify-content-start'
                showLabels
                value={value}
                onChange={(event, newValue) => {
                    setValue(newValue);
                }}
            >
                <BottomNavigationAction
                    id="firstSelected"
                    sx={{
                        flex: "0 0 auto",
                        padding: "0px",
                        height:'0px !important',
                        color: "#333333",
                        fontSize: "14px !important",
                        backgroundColor:'#f3f3f3',
                        padding:'18px 30px !important',
                        borderRadius:'40px',
                        "& .MuiBottomNavigationAction-label": {
                          whiteSpace: "nowrap !important",
                          fontWeight: "500",
                          fontSize: "14px !important",
                        },
                        ".Mui-selected&": {
                          color: "#fff",
                          fontSize: "14px !important",
                          backgroundColor:'rgba(191, 29, 45, 0.8)',
                          padding:'18px 30px !important',
                          borderRadius:'40px'
                        },
                    }}
                    label="All"
                    className={'p-0'}
                    component={step === 'preAccept' ? Link : undefined}
                    to={'/firehouse/my-shifts'}
                />
                <BottomNavigationAction
                    sx={{
                        flex: "0 0 auto",
                        padding: "0px",
                        height:'0px !important',
                        color: "#333333",
                        fontSize: "14px !important",
                        backgroundColor:'#f3f3f3',
                        padding:'18px 30px !important',
                        borderRadius:'40px',
                        "& .MuiBottomNavigationAction-label": {
                          whiteSpace: "nowrap !important",
                          fontWeight: "500",
                          fontSize: "14px !important",
                        },
                        ".Mui-selected&": {
                          color: "#fff",
                          fontSize: "14px !important",
                          backgroundColor:'rgba(191, 29, 45, 0.8)',
                          padding:'18px 30px !important',
                          borderRadius:'40px'
                        },
                    }}
                    label="Scheduled Shifts"
                    className={'mx-2 p-0'}
                    component={step === 'preAccept' ? Link : undefined}
                    to={'/firehouse/my-shifts?step=1'}
                />
                <BottomNavigationAction
                    sx={{
                        flex: "0 0 auto",
                        padding: "0px",
                        height:'0px !important',
                        color: "#333333",
                        fontSize: "14px !important",
                        backgroundColor:'#f3f3f3',
                        padding:'18px 30px !important',
                        borderRadius:'40px',
                        "& .MuiBottomNavigationAction-label": {
                          whiteSpace: "nowrap !important",
                          fontWeight: "500",
                          fontSize: "14px !important",
                        },
                        ".Mui-selected&": {
                          color: "#fff",
                          fontSize: "14px !important",
                          backgroundColor:'rgba(191, 29, 45, 0.8)',
                          padding:'18px 30px !important',
                          borderRadius:'40px'
                        },
                    }}
                    label="Overtime Shifts"
                    className={'p-0'}
                    component={step === 'preAccept' ? Link : undefined}
                    to={'/firehouse/my-shifts?step=2'}
                />
                <BottomNavigationAction
                    sx={{
                        flex: "0 0 auto",
                        padding: "0px",
                        height:'0px !important',
                        color: "#333333",
                        fontSize: "1rem !important",
                        backgroundColor:'#f3f3f3',
                        padding:'18px 30px !important',
                        borderRadius:'40px',
                        "& .MuiBottomNavigationAction-label": {
                          whiteSpace: "nowrap !important",
                          fontWeight: "500",
                          fontSize: "14px !important",
                        },
                        ".Mui-selected&": {
                          color: "#fff",
                          fontSize: "14px !important",
                          backgroundColor:'rgba(191, 29, 45, 0.8)',
                          padding:'18px 30px !important',
                          borderRadius:'40px'
                        },
                    }}
                    label="Details"
                    className={'mx-2 p-0'}
                    component={step === 'preAccept' ? Link : undefined}
                    to={'/firehouse/my-shifts?step=3'}
                />
                {
                  pages.includes('MENU_PRE_ACCEPT') && <BottomNavigationAction
                    sx={{
                        flex: "0 0 auto",
                        padding: "0px",
                        height:'0px !important',
                        color: "#333333",
                        fontSize: "14px !important",
                        backgroundColor:'#f3f3f3',
                        padding:'18px 30px !important',
                        borderRadius:'40px',
                        "& .MuiBottomNavigationAction-label": {
                          whiteSpace: "nowrap !important",
                          fontWeight: "500",
                          fontSize: "14px !important",
                        },
                        ".Mui-selected&": {
                          color: "#fff",
                          fontSize: "14px !important",
                          backgroundColor:'rgba(191, 29, 45, 0.8)',
                          padding:'18px 30px !important',
                          borderRadius:'40px'
                        },
                    }}
                    label="Pre Accept"
                    className={'p-0'}
                    component={step === 'preAccept' ? Link : undefined}
                    to={'/firehouse/my-shifts?step=4'}
                />
                }
                

                {pages.includes('V3_OT_SWAPS_FEATURE') && 
                  <BottomNavigationAction
                    sx={{
                        flex: "0 0 auto",
                        padding: "0px",
                        height:'0px !important',
                        color: "#333333",
                        fontSize: "14px !important",
                        backgroundColor:'#f3f3f3',
                        padding:'18px 30px !important',
                        borderRadius:'40px',
                        "& .MuiBottomNavigationAction-label": {
                          whiteSpace: "nowrap !important",
                          fontWeight: "500",
                          fontSize: "14px !important",
                        },
                        ".Mui-selected&": {
                          color: "#fff",
                          fontSize: "14px !important",
                          backgroundColor:'rgba(191, 29, 45, 0.8)',
                          padding:'18px 30px !important',
                          borderRadius:'40px'
                        },
                    }}
                    label="User Swaps List"
                    className={'mx-2 p-0'}
                    onClick={handleLoadOT}
                    component={step === 'preAccept' ? Link : undefined}
                    to={'/firehouse/my-shifts?step=5'}
                />}

                {pages.includes('V3_VAC_SWAPS_FEATURE') && 
                  <BottomNavigationAction
                      sx={{
                          flex: "0 0 auto",
                          padding: "0px",
                          height:'0px !important',
                          color: "#333333",
                          fontSize: "14px !important",
                          backgroundColor:'#f3f3f3',
                          padding:'18px 30px !important',
                          borderRadius:'40px',
                          "& .MuiBottomNavigationAction-label": {
                            whiteSpace: "nowrap !important",
                            fontWeight: "500",
                            fontSize: "14px !important",
                          },
                          ".Mui-selected&": {
                            color: "#fff",
                            fontSize: "14px !important",
                            backgroundColor:'rgba(191, 29, 45, 0.8)',
                            padding:'18px 30px !important',
                            borderRadius:'40px'
                          },
                      }}
                      label="Vacation Swaps"
                      className={'mx-2 p-0'}
                      component={step === 'preAccept' ? Link : undefined}
                      to={'/firehouse/my-shifts?step=6'}
                  />
                }

								 {pages.includes('V3_Volunteer_Signup') && 
										<BottomNavigationAction
												sx={{
														flex: "0 0 auto",
														padding: "0px",
														height:'0px !important',
														color: "#333333",
														fontSize: "1rem !important",
														backgroundColor:'#f3f3f3',
														padding:'18px 30px !important',
														borderRadius:'40px',
														"& .MuiBottomNavigationAction-label": {
															whiteSpace: "nowrap !important",
															fontWeight: "500",
															fontSize: "14px !important",
														},
														".Mui-selected&": {
															color: "#fff",
															fontSize: "14px !important",
															backgroundColor:'rgba(191, 29, 45, 0.8)',
															padding:'18px 30px !important',
															borderRadius:'40px'
														},
												}}
												label={pillHeading}
												className={'mx-2 p-0'}
												component={step === 'preAccept' ? Link : undefined}
												to={'/firehouse/my-shifts?step=7'}
										/>
									}

									{/* {pages.includes('V3_Volunteer_Signup') && 
										<BottomNavigationAction
												sx={{
														flex: "0 0 auto",
														padding: "0px",
														height:'0px !important',
														color: "#333333",
														fontSize: "1rem !important",
														backgroundColor:'#f3f3f3',
														padding:'18px 30px !important',
														borderRadius:'40px',
														"& .MuiBottomNavigationAction-label": {
															whiteSpace: "nowrap !important",
															fontWeight: "500",
															fontSize: "14px !important",
														},
														".Mui-selected&": {
															color: "#fff",
															fontSize: "14px !important",
															backgroundColor:'rgba(191, 29, 45, 0.8)',
															padding:'18px 30px !important',
															borderRadius:'40px'
														},
												}}
												label="Volunteer Shifts"
												className={'mx-2 p-0'}
												component={step === 'preAccept' ? Link : undefined}
												to={'/firehouse/my-shifts?step=8'}
										/>
									} */}

            </BottomNavigation>
        </Paper>
    );
}
